/**
 * 解锁过渡动画组件
 * 处理从 3 阶段卡片到时间轴的平滑过渡
 * 使用 framer-motion 实现右侧滑入动画
 */

import { motion, AnimatePresence } from "framer-motion";
import { ReactNode } from "react";

interface UnlockTransitionProps {
  /** 是否已解锁 */
  isUnlocked: boolean;
  /** 未解锁时显示的内容（3 阶段卡片） */
  previewContent: ReactNode;
  /** 已解锁时显示的内容（时间轴） */
  unlockedContent: ReactNode;
  /** 自定义类名 */
  className?: string;
}

export function UnlockTransition({
  isUnlocked,
  previewContent,
  unlockedContent,
  className,
}: UnlockTransitionProps) {
  return (
    <div className={className}>
      <AnimatePresence mode="wait" initial={false}>
        {!isUnlocked ? (
          <motion.div
            key="preview"
            initial={{ opacity: 1, x: 0 }}
            exit={{
              opacity: 0,
              x: -100,
              transition: {
                duration: 0.3,
                ease: [0.4, 0, 0.2, 1],
              },
            }}
          >
            {previewContent}
          </motion.div>
        ) : (
          <motion.div
            key="unlocked"
            initial={{
              opacity: 0,
              x: 100,
            }}
            animate={{
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.5,
                ease: [0.4, 0, 0.2, 1],
                delay: 0.1,
              },
            }}
          >
            {unlockedContent}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default UnlockTransition;
